/* PSF sections: rail arrows, tabs, footer accordions. No dependencies. */
(() => {
  const ready = (fn) => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));

  const activeTrack = (root) => {
    const panel = root.querySelector('.psf-rail__panel.is-active');
    return (panel || root).querySelector('[data-psf-track]');
  };

  const updateArrows = (root) => {
    const track = activeTrack(root);
    if (!track) return;
    const prev = root.querySelector('[data-psf-prev]');
    const next = root.querySelector('[data-psf-next]');
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    root.classList.toggle('psf-no-scroll', max <= 2);
  };

  const initRail = (root) => {
    if (root.dataset.psfReady) return;
    root.dataset.psfReady = '1';
    root.querySelectorAll('[data-psf-prev],[data-psf-next]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const track = activeTrack(root);
        if (!track) return;
        const dir = btn.hasAttribute('data-psf-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      });
    });
    root.querySelectorAll('[data-psf-track]').forEach((track) => {
      track.addEventListener('scroll', () => updateArrows(root), { passive: true });
    });
    const tabs = root.querySelectorAll('[data-psf-tab]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const idx = tab.dataset.psfTab;
        tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        root.querySelectorAll('[data-psf-panel]').forEach((p) => {
          const on = p.dataset.psfPanel === idx;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        root.querySelectorAll('.psf-rail__link').forEach((a) => { if (tab.dataset.url) a.href = tab.dataset.url; });
        updateArrows(root);
      });
    });
    updateArrows(root);
  };

  const initFooter = () => {
    const desktop = window.matchMedia('(min-width: 750px)');
    const sync = () => document.querySelectorAll('.psf-footer__menu').forEach((d) => { if (desktop.matches) d.open = true; });
    sync();
    desktop.addEventListener('change', sync);
  };

  // Full-screen heroes subtract the real header stack (announcement + header + sub-nav), not just the header.
  const setHeaderStack = () => {
    let h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach((s) => {
      if (getComputedStyle(s).position !== 'fixed') h += s.offsetHeight;
    });
    if (h) document.documentElement.style.setProperty('--psf-header-stack', `${h}px`);
  };

  const init = () => {
    setHeaderStack();
    document.querySelectorAll('[data-psf-rail]').forEach(initRail);
    initFooter();
  };

  ready(init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', () => { setHeaderStack(); document.querySelectorAll('[data-psf-rail]').forEach(updateArrows); }, { passive: true });
})();
